import React, { useCallback, useState } from "react";
import DashRevenueMetricCard from "./DashRevenueMetricCard";
import DashRevenueMetricsPickerCard from "./DashRevenueMetricsPickerCard";
import {
  buildRevenueMetricCardProps,
  loadSelectedRevenueMetrics,
  saveSelectedRevenueMetrics,
} from "./revenueMetricsConfig";

export default function DashRevenueMetricsStrip({
  loading,
  revenueKpis,
  currencySign = "₹",
}) {
  const [selectedIds, setSelectedIds] = useState(() => loadSelectedRevenueMetrics());

  const handleChange = useCallback((ids) => {
    setSelectedIds(ids);
    saveSelectedRevenueMetrics(ids);
  }, []);

  return (
    <div className="row g-4 g-lg-5 mb-5 analytics-cards-revenue">
      
      {selectedIds.map((id) => {
        const props = buildRevenueMetricCardProps(id, revenueKpis, currencySign);
        if (!props) return null;
        return (
          <div key={id} className="col-6 col-xl-3">
            <DashRevenueMetricCard
              {...props}
              loading={loading}
              onRemove={() => handleChange(selectedIds.filter((x) => x !== id))}
            />
          </div>
        );
      })}
      <div className="col-6 col-xl-3">
        <DashRevenueMetricsPickerCard
          selectedIds={selectedIds}
          onChange={handleChange}
          loading={loading}
          revenueKpis={revenueKpis}
        />
      </div>
    </div>
  );
}
